import { authFetch } from "../utils/authFetch"
import { API_BASE_URL } from "../config"

// Configuración de la URL base
const BASE_URL = `${API_BASE_URL}/api/sucursales`;

/**
 * Obtiene el ID de la empresa del localStorage.
 */
const getEmpresaId = () => {
  return localStorage.getItem("idempresa");
};

/**
 * Obtiene todas las sucursales de la empresa actual (GET).
 */
export const getSucursales = async () => {
  const empresaId = getEmpresaId();
  const url = `${BASE_URL}/empresa/${empresaId}`;

  const response = await authFetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar las sucursales");
  }

  return response.json();
};

/**
 * Obtiene todas las sucursales (GET) - Versión de desarrollo.
 */
export const getSucursalesDev = async () => {
  const response = await authFetch(BASE_URL, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar las sucursales");
  }

  return response.json();
};

/**
 * Crea una nueva sucursal (POST).
 */
export const createSucursal = async (sucursalData) => {
  const response = await authFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(sucursalData),
  });

  if (!response.ok) {
    throw new Error("Error al crear la sucursal");
  }

  return response.json();
};

/**
 * Actualiza una sucursal existente (PUT).
 */
export const updateSucursal = async (id, sucursalData) => {
  const url = `${BASE_URL}/${id}`;

  const response = await authFetch(url, {
    method: "PUT",
    body: JSON.stringify(sucursalData),
  });

  if (!response.ok) {
    throw new Error("Error al actualizar la sucursal");
  }

  return response.json();
};

/**
 * Obtiene una sucursal específica por ID (GET by ID).
 */
export const getSucursalById = async (id) => {
  const url = `${BASE_URL}/${id}`;

  const response = await authFetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar la sucursal por ID");
  }

  return response.json();
};

/**
 * Obtiene las sucursales por empresaId (GET by empresaId).
 */
export const getSucursalesByEmpresaId = async (empresaId) => {
  const url = `${BASE_URL}/empresa/${empresaId}`;

  const response = await authFetch(url, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Error al consultar las sucursales por empresa");
  }

  return response.json();
};